module.exports = __webpack_public_path__ + "img/2.318d4258.png";